import React from "react";
import "./style.css";
import "./social-hover.css";
import "./dark-theme.css";
// import TwitterIcon from "../../assets/img/twitter.svg";
import LinkedinIcon from "../../assets/img/linkedin.svg";
import InstagramIcon from "../../assets/img/instagram.svg";
import WhatsAppIcon from "../../assets/img/whatsapp.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";


/* global gtag */


const OuterFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionClassName, e) => {
    e.preventDefault();
    

    if (location.pathname === "/") {
      const section = document.querySelector(`.${sectionClassName}`);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If we're not on the Education page, navigate there first and then scroll
      navigate('/', { state: { scrollTo: sectionClassName } });
    }
  };

  const handleContactUsClick = (sectionClassName, e) => {
    e.preventDefault();

    if (typeof gtag !== 'undefined') {
      gtag('event', 'ads_conversion_Contact_Us_1', {
        'event_callback': () => {
          scrollToSection(sectionClassName, e);
        },
        'event_timeout': 2000,
      });
    } else {
      // Fallback: if gtag is not available, directly execute the action
      scrollToSection(sectionClassName, e);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main-content">
          <div className="footer-brand-section">
            <h3 className="brand-name">Chanakya AI</h3>
            <p className="tagline">
              Empowering students and institutions with AI-driven personalized
              learning experiences.
            </p>
            <div className="social-icons">
              {/* <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src={TwitterIcon} alt="Twitter" width="24" height="24" />
              </a> */}
              <a
                href="https://www.linkedin.com/company/neurobridge-tech"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src={LinkedinIcon} alt="LinkedIn" width="24" height="24" />
              </a>
              <a
                href="https://www.instagram.com/chanakya.ai_official?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src={InstagramIcon} alt="Instagram" width="24" height="24" />
              </a>
              <a
                href="https://chat.whatsapp.com/Dj537r8v1mS5AgWh1yGGtt?mode=ac_c"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src={WhatsAppIcon} alt="WhatsApp Community" width="24" height="24" />
              </a>
             
            </div>
          </div>

          <div className="footer-links-section">
            <div className="link-column">
              <h4 className="column-title">For Students</h4>
              <ul className="footer-links">
                <li>
                  <button 
                    className="link-button" 
                    onClick={(e) => scrollToSection('student-learning-section', e)}
                  >
                    Student Benefits
                  </button>
                </li>
                <li>
                  <button 
                    className="link-button" 
                    onClick={(e) => scrollToSection('ai-teachers-section', e)}
                  >
                    AI Teachers
                  </button>
                </li>
                <li>
                  <Link to="https://app.aichanakya.in/">Sign Up Free</Link>
                </li>
                <li>
                  <Link to="https://app.aichanakya.in/">Student Login</Link>
                </li>
              </ul>
            </div>

            <div className="link-column">
              <h4 className="column-title">For Institutions</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/blogs">Blogs</Link>
                </li>
                <li>
                  <a 
                    href="https://calendly.com/atharv-gyem/discovery-call" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Request Demo
                  </a>
                </li>
                <li>
                  <Link to="/blog/simplify-grading-middle-school">Case Studies</Link>
                </li>
              </ul>
            </div>

            <div className="link-column">
              <h4 className="column-title">Support</h4>
              <ul className="footer-links">
                <li>
                  <button 
                    className="link-button" 
                    onClick={(e) => handleContactUsClick('get-in-touch-section', e)}
                  >
                    Help Center
                  </button>
                </li>
                <li>
                  <Link to="/tos">Terms Of Service</Link>
                </li>
                <li>
                  <button 
                    className="link-button" 
                    onClick={(e) => handleContactUsClick('get-in-touch-section', e)}
                  >
                    Contact Us
                  </button>
                </li>
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/careers">Careers</Link>
                </li>
                <li>
                  <Link to="/refundpolicy">Refund and Cancellation Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-wrapper">
          <div className="copyWrite-box">
            <p className="copywrite-text">
              © 2024 NeuroBridge Tech Private Limited. All rights reserved.
            </p>
            <ul className="btn-list">
              <li className="btn-item">
                <Link to="/tos" className="btn-text">
                  Terms of Service
                </Link>
              </li>
              <li className="btn-item">
                <Link to="/privacy" className="btn-text">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          <h6 className="made-with-text">
            Made with ❤️  India
          </h6>
        </div>
      </div>
    </footer>
  );
};

export default OuterFooter;
